import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { CompanyProfileServiceProxy } from '@shared/service-proxies/service-proxies';
import { AbpSessionService } from 'abp-ng2-module';

@Injectable({
    providedIn: 'root'
  })
export class UsersDateFormatService {


    constructor(private _companyProfile: CompanyProfileServiceProxy,
                private _abpSessionService: AbpSessionService) {}           

  findUsersDateFormat(formatType: number): string {
    let dateType = Number(formatType);
    switch (dateType) {
        case 1: {
            return 'dd/MM/yyyy';
        }
        case 2: {
            return 'MM/dd/yyyy';
        }
        case 3: {
            return 'yyyy/dd/MM';
        }
        default: {
            return 'dd/MM/yyyy';
        }
    }
  }

  async getCompanyDateTypeInfo(): Promise<string> {
      if (!AppConsts?.companyDetails) {
          if (this._abpSessionService.tenantId) {
              await this._companyProfile.getCompanyProfileDetailsForEditView(this._abpSessionService.tenantId).subscribe(x => {
                  this.returnDateType(x); AppConsts.companyDetails = x;
              });
          }
          else {
              await this._companyProfile.getCompanyProfileDetailsForEditView(undefined).subscribe(x => {
                  this.returnDateType(x); AppConsts.companyDetails = x;
              });
          }
    
    } else {
      return this.returnDateType(AppConsts.companyDetails);
    }
  }
  returnDateType(x) {
    let datetypestr:string='';
    let dateType = x.dateFormat; 
    switch (dateType) {
      case 1: {
        datetypestr='dd/MM/yyyy';
      }
      case 2: {
        datetypestr='MM/dd/yyyy';
      }
      case 3: {
        datetypestr='yyyy/MM/dd';
      }
      default: {
        datetypestr='dd/MM/yyyy';
      }
    }

    return datetypestr;
  }

//   getCompanyDateTypeInfo(): string {
//     this._companyProfile.getCompanyProfileDetailsForEditView(this._abpSessionService.tenantId).subscribe(x => { 
//       let dateType=x.dateFormat; 
//         switch (dateType) {
//           case 1: {
//               return 'dd/MM/yyyy';
//           }
//           case 2: {
//               return 'MM/dd/yyyy';
//           }
//           case 3: {
//               return 'yyyy/MM/dd';
//           }
//           default: {
//               return 'dd/MM/yyyy';
//           }
//         }
//     });
// }


}
